import React, { useEffect, useState } from "react";
import EventLabel2, { init } from "../../../components/EventLabel2/EventLabel2";
import VonageSpeakerDialog from "../Vonage/components/VonageSpeakerDialog";

export const VideoWallModule = (props) => {
  const [dialogOpen, setDialogOpen] = useState(false);
  const [timesKicked, setTimesKicked] = useState(0);
  const [videoWallProps, setVideoWallProps] = useState(null);
  const [videoWallFull, setVideoWallFull] = useState(false);
  const { hubConnection, clientKey, eventId, lang, settings, preview, template, channel } = props;
  const { wallName, balanceScreens = false, backgroundColor, color, borderRadius, borderColor, borderWidth, fontSize, useTemplateStyle } = settings;
  useEffect(() => {
    init(eventId, "DigitalMeeting.VideoWall", lang);

  }, []);
  useEffect(() => {
    if (hubConnection && hubConnection.connectionState == 1) {
      hubConnection.on("onGetTokenForVideoWall", onGetTokenForVideoWall);
      hubConnection.on("onVideoWallFull", onVideoWallFull);
      hubConnection.on("onKickPersonFromWall", onKickPersonFromWall);
    }
    return () => {
      if (hubConnection && hubConnection.connectionState == 1) {
        hubConnection.off("onGetTokenForVideoWall", onGetTokenForVideoWall);
        hubConnection.off("onVideoWallFull", onVideoWallFull);
        hubConnection.off("onKickPersonFromWall", onKickPersonFromWall);
      }
    }
  });
  const buttonStyle = {
    padding: "6px 12px",
    minWidth: "50px",
    width: "100%",
    height: "auto",

    backgroundColor: backgroundColor != "unset" && useTemplateStyle ? backgroundColor : template.button.backgroundColor,
    borderRadius: borderRadius != "unset" && useTemplateStyle ? borderRadius : template.button.borderRadius,
    color: color != "unset" && useTemplateStyle ? color : template.button.color,
    padding: "6px 12px 6px 12px",
    borderColor: borderColor != "unset" && useTemplateStyle ? borderColor : template.button.borderColor,
    fontSize: fontSize != "unset" && useTemplateStyle ? fontSize : template.button.fontSize,
    borderWidth: borderWidth != "unset" && useTemplateStyle ? borderWidth : template.button.borderWidth,
    borderStyle: borderWidth != "unset" && useTemplateStyle ? "solid" : undefined,
  };
  const onKickPersonFromWall = (name, key) => {
    if (wallName?.toLowerCase() === name.toLowerCase() && clientKey === key) {
      setTimesKicked(timesKicked + 1);
    }
  }
  const onGetTokenForVideoWall = (apiKey, sessionId, token) => {
    setVideoWallProps({ apiKey, sessionId, token, wallName });
    setDialogOpen(true);
  }
  const onVideoWallFull = () => {
    setVideoWallFull(true);
    setTimeout(() => setVideoWallFull(false), 5000);
  }
  const requestSession = () => {
    if (hubConnection && hubConnection.connectionState == 1) {
      hubConnection.invoke("getTokenForVideoWall", eventId, wallName.toLowerCase(), clientKey, balanceScreens);
    }
  };
  const handleDialogClose = () => {
    setDialogOpen(false);
    setVideoWallProps(null);
  }
  const api = {
    ...props,
    videoWallProps,
    videoWall: true,
    handleClose: handleDialogClose
  };
  return (
    <div>
      {dialogOpen && videoWallProps ? <VonageSpeakerDialog {...api} /> : null}
      <button
        disabled={preview || videoWallFull || (timesKicked >= 5)}
        style={template ? { ...template.button, ...buttonStyle } : {}}
        onClick={() => requestSession()}
      >
        {!videoWallFull && (timesKicked < 5) ? <EventLabel2 name="ConnectToVideoWall" groupName="DigitalMeeting.VideoWall" /> : null}
        {videoWallFull && (timesKicked < 5) ? <EventLabel2 name="VideoWallFullWarn" groupName="DigitalMeeting.VideoWall" /> : null}
        {(timesKicked >= 5) ? <EventLabel2 name="VideoWallBlocked" groupName="DigitalMeeting.VideoWall" /> : null}
      </button>
    </div>
  );
};
